import styled from '@emotion/styled';
import { TextField } from '../../../components/TextField/component';
import { ActionPromiseButton } from '../../../components/Buttons/ActionButton/ActionPromiseButton';

export const Heading = styled('div')({
  fontSize: 18,
  borderBottom: '1px solid #CACACA',
  fontWeight: 600,
  lineHeight: '35px',
  marginBottom: 20,
});

export const SubHeading = styled('div')({
  fontSize: 16,
  fontWeight: 600,
  marginTop: 24,
  marginBottom: 16,
});

export const TextFieldLabel = styled('div')(
  ({ hoverable = false }: { hoverable?: boolean }) => ({
    marginTop: 11,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '19px',
    color: '#002B3E',
    marginBottom: 4,
    width: 'fit-content',
    ':hover': {
      cursor: hoverable ? 'pointer' : 'auto',
    },
  })
);

export const StyledTextField = styled(TextField)({
  width: '100%',
});

export const FormWrapper = styled('div')({
  maxWidth: 508,
});

export const InstitutionUrlFieldWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const OLUrlPrefix = styled('span')({
  margin: '0 15px',
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.55)',
});

export const StyledActionButton = styled(ActionPromiseButton)({
  marginTop: 25,
  width: 160,
});

export const StyledLink = styled('a')({
  color: 'white',
});

export const InstitutionsTablePaginationContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: 16,
});

export const SelectFlexContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const SelectTotalPagesContainer = styled('div')({
  marginLeft: 8,
});

export const InsitutionsSectionWrapper = styled('div')({
  marginTop: 8,
});
